import * as React from 'react';
import { AppDispatch, RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import { getStartDate } from '../utils/utils';
import { fetchOrders } from '../reducers/positionSlice';
import { OrdersPage } from '../routes/orders-page';
import { calculateRealizedPnL, getOrdersHistoryFetchDate } from '../utils/orderPnL';

export const OrdersPageContainer: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { orders } = useSelector((state: RootState) => state.alpaca);
    const [period, setPeriod] = React.useState('1M');
    const periodStartDate = React.useMemo(() => getStartDate(period, new Date()), [period]);

    React.useEffect(() => {
        dispatch(fetchOrders(getOrdersHistoryFetchDate()));
    }, [dispatch]);

    const updateOrders = (newPeriod: string) => {
        setPeriod(newPeriod);
    };

    if (!orders.length) {
        return <p>Loading...</p>;
    }

    const { profitLoss, tradeHistory } = calculateRealizedPnL(orders, periodStartDate);

    return (
        <OrdersPage
            orders={orders}
            tradeHistory={tradeHistory}
            profitLoss={profitLoss}
            chartPeriod={period}
            periodStartDate={periodStartDate}
            updateOrders={updateOrders}
        />
    );
};
